import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AbstractControl, FormArray, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { SurveysService } from '../../services';


export interface SurveyQuestionsModel {
	title:string;
    button:string;
    id:any,
    question_id:any;
    edit:boolean;
}

@Component({  
    selector: 'add-edit-survey-questions',
    templateUrl: './add-edit-survey-questions.html',
    styleUrls: ['./add-edit-survey-questions.scss']
})

export class SurveyQuestionsModalComponent extends DialogComponent<SurveyQuestionsModel, any> implements SurveyQuestionsModel, OnInit {
  	title:string;
    button:string;
    id:any;
    question_id:any;
    edit:boolean;

    private addEditForm: FormGroup;
    private description:AbstractControl;
    private question_type:AbstractControl;

    private question_type_arr=[
        {
            id: 1,
            name: 'Tekstualni'
        },
        {
            id: 2,
            name: 'Brojčani'
        },
        {
            id: 3,
            name: 'Više odgovora'
        },
        {
            id: 4,
            name: 'Jedan odgovor'
        }
    ]

    private number_of_answers = [1];

    private dataToSend = {
        description: '',
        question_type: null,
        answers: []
    }

    private errorMsg:string = '';

  	constructor(
        dialogService: DialogService,
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private surveysService: SurveysService
    ) {
    	super(dialogService);
  	}

    ngOnInit() {
        this.addEditForm = this.formBuilder.group({
            description: ['', Validators.required],
            question_type: [null, Validators.required],
            answers: this.formBuilder.array([
                this.initAnswers(),
            ])
        });

        this.description = this.addEditForm.controls['description'];
        this.question_type = this.addEditForm.controls['question_type'];

        this.addEditForm.controls['question_type'].valueChanges.subscribe((value) => {
            if(value === 3 || value === 4){
                this.addEditForm.controls.answers.enable();
                if(this.number_of_answers.length < 1){
                    this.number_of_answers = [1];
                }
            } else {
                this.addEditForm.controls.answers.disable();
            }
        });

        if(this.question_id !== null){
            this.getSpecificQuestion();
        }
    }

    initAnswers() {
        if(this.edit){
            return this.formBuilder.group({
                position: [null, Validators.required],
                description: ['', Validators.required],
                id: ['']
            });
        } else {
            return this.formBuilder.group({
                position: [null, Validators.required],
                description: ['', Validators.required]
            });
        }
    }

    addAnswers() {
        const control = <FormArray>this.addEditForm.controls['answers'];
        control.push(this.initAnswers());
        this.number_of_answers.push(this.addEditForm.controls.answers.value.length)
    }

    removeAnswers(i: number) {
        const control = <FormArray>this.addEditForm.controls['answers'];
        control.removeAt(i);
        this.number_of_answers.splice(-1,1);
        for(let i = 0; i < this.number_of_answers.length; i++){
            control.controls[i].get('position').reset();
        }
    }

    getSpecificQuestion() {
        this.surveysService.getSpecificQuestion(this.id, this.question_id).subscribe(
            response => {
                this.number_of_answers = [];
                const control = <FormArray>this.addEditForm.controls['answers'];

                for(let i = 0; i < response.question.answers.length; i++){
                    this.number_of_answers.push(response.question.answers[i].position);

                    if(i > 0){
                        control.push(this.initAnswers());
                    }
                    control.controls[i].get('position').setValue(response.question.answers[i].position);
                    control.controls[i].get('description').setValue(response.question.answers[i].description);
                    control.controls[i].get('id').setValue(response.question.answers[i].id);
                }

                const question = {
                    description: response.question.description,
                    question_type: response.question.question_type
                };
                this.addEditForm.patchValue(question, { onlySelf: true });
            },
            error => {
                if(error.error_msg){
                    this.errorMsg = error.error_msg;
                    this.toastr.error(error.error_msg);
                }
            },
        );
    }

    confirm() {
        // we set dialog result as true on click on confirm button, 
        // then we can get dialog result from caller code

        this.dataToSend.description = this.addEditForm.value.description;
        this.dataToSend.question_type = this.addEditForm.value.question_type;

        if(this.addEditForm.value.question_type === 3 || this.addEditForm.value.question_type === 4){
            this.dataToSend.answers = this.addEditForm.value.answers;
        } else {
            delete this.dataToSend.answers;
        }

        if(this.edit){
            this.surveysService.editQuestion(this.id, this.question_id, this.dataToSend).subscribe(
                response => {
                    this.toastr.success(response.message);
                    this.close();
                },
                error => {
                    if (error.errors && error.errors.length !== 0) {
                        for (let i = 0; i < error.errors.length; i++) {
                            this.errorMsg = error.errors[i].description;
                            this.toastr.error(error.errors[i].description);
                        }
                    } else {
                        this.errorMsg = error.error_msg;
                        this.toastr.error(error.error_msg);
                    }
                },
            );
        } else {
            this.surveysService.addQuestion(this.id, this.dataToSend).subscribe(
                response => {
                    this.toastr.success(response.message);
                    this.close();
                },
                error => {
                    if (error.errors && error.errors.length !== 0) {
                        for (let i = 0; i < error.errors.length; i++) {
                            this.errorMsg = error.errors[i].description;
                            this.toastr.error(error.errors[i].description);
                        }
                    } else {
                        this.errorMsg = error.error_msg;
                        this.toastr.error(error.error_msg);
                    }
                },
            );
        }
    }
}



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/modals/add-edit-survey-questions/add-edit-survey-questions.component.ts